/**
 *  使用 单个更新
 */
import React, { useState, } from 'react';
import { Row, Col, Input,InputNumber,Switch,Select, } from 'antd';
import LazyLoad from 'react-lazyload';
import ImageHover from "../../Components/ImageHover";
import CopyAndPaste from "../../../../components/CopyAndPaste/CopyAndPaste";
import StickerTemplateSelector from "../../Components/StickerTemplateSelector";
import CertificateNew from '../Certificate/CertificateNew';
import LoadFree from "@components/LazyNode/load-free";
import {isEmpty,isEmptyObject,trim,getFileSuffix,cloneObj} from '@utils/utils';
import CustomsDeclarationStickerAction from "../../CustomsDeclarationSticker.action";
import Lang from "@components/Lang/Lang";
const { TextArea } = Input;
const config = require("@config/config");
const OneItem = (props) => {
    const {
        model={},//详情的model
        item = {},//对应项
        isEdit=false,
        isHadEdit=false,
        setHadEdit=null,
        inx=0,
        isSubmit="",
        portalUrl = config.servers[config.environment].portalUrl,
        iconCodeList=[],
        saveOther
    } = props;
    const [ kiaCard, setKiaCard, ] = useState({});
    const [curChaObj, setCurChaObj, ] = useState(cloneObj(item));
    const [ kizAttrList, setKizAttrList] = useState([]);
    const [ attrList, setAttrList] = useState([]);
    const [ kizCategoryVO, setKizCategoryVO, ] = useState(item.kizCategoryVO||{});
    const [ attValues, setAttValues, ] = useState(item.attValues||{});
    const [ iconCodeMore, setIconCodeMore, ] = useState(false);

    // 属性列表
    const renderAttribute = (attributeList=[])=>{
        let childAtt = [];
        attributeList.forEach((att,inx)=>{
            if(att.optionList&&att.optionList.length>0){
                childAtt.push(<Col key={"at_"+inx} span={inx==0?6:12} className={'descItem'}>{att.attributeName}
                    {att.optionList.map((opt, suInx)=>(<span key={"at_"+inx+'_o-'+suInx}>{opt.optionName}</span>))}
                </Col>)
            }
        })
        return childAtt;
    }
    /**
     * 菜单
     * */
    const renderRow =(title="",required=false,content)=>{
        return (<div className={"flex-item mb_12 rowInput"}>
            <div className={"leftW mr_8 black45"}>{title}{required?<span className={"star ml_2"}>*</span>:null}</div>
            <div className={"flex-1 rightShow"}>
                {content}
            </div>
        </div>)
    }
    const getGtinInfo = (curChaObj)=>{
        if(curChaObj.skuId&&curChaObj.customsCode&&curChaObj.isMandatoryFlag){
            const data = {
                skuId:curChaObj.skuId,
                customsCode:curChaObj.customsCode,
            }
            CustomsDeclarationStickerAction.postHttpAction('/service/mg/sticker/track/query-kiz-attr-by-customs-code',data).then(res=>handleGtinRes(res.data)).catch(err=>handleGtinRes(err));
        }
    }
    const handleGtinRes =(res)=>{
        if(res.success&&res.valid){
            setKizAttrList(res.models||[]);//本页面用
            onChangeField(res.models,'kizAttrList');//保存匹配用
            onChangeField(res.model||"",'gtinCode');// gtinCode
            if(res.models&&res.models.length>0){
                const catObj = res.models.find(arr=>arr.isSelect==1);
                let yKiaObj = {};
                if(catObj&&catObj.isSelect){// 保存 一份原始商品卡片数据
                    // console.log("一份原始商品卡片数据",catObj);
                    yKiaObj = {...catObj};
                    setKiaCard(yKiaObj);
                    // checkUpdateGtin(newObj) 设置顺序有问题会有影响，屏蔽
                }
                // 设置当前值
                if(kizCategoryVO.catId){
                    const kizObj = res.models.find(arr=>arr.catId==kizCategoryVO.catId);
                    if(kizObj&&kizObj.catId){
                        handleKiaChange("cate",kizObj.catId,kizObj,true,yKiaObj);
                    }else {
                        handleKiaChange("cate","",{},true,yKiaObj);
                    }
                }else if(catObj&&catObj.catId){
                        handleKiaChange("cate",catObj.catId,catObj,true,yKiaObj);
                }
                // console.log("catObj",catObj);

            }else {
                handleKiaChange("cate","",{},true);
            }
        }
    }
    /*
   * 匹配
   * 异常列表
   * @only 仅一个
   * */
    function matchCode(code="",list) {
        if(list&&list.includes(code)){ //含有该 CODE返回TRUE
            return true
        }else return false;
    }
    /*
    * KiaChange
    * filed 字段
    * data 对应数据
    * option 对应数据行
    * flagInitAuto 是否初始化赋值
    * */
    const handleKiaChange =(filed,data,option={},flagInitAuto=false,yKiaObj)=>{
        let newObj = {...attValues};
        if(filed=='cate'){
            let newCategoryAttrList = kizCategoryVO.categoryAttrList||[];
            if(option.categoryAttrList&&option.categoryAttrList.length){
                option.categoryAttrList.forEach(kiaArr=>{
                    if(kiaArr.attrPresetList&&kiaArr.attrPresetList.length>0){
                        let list = [];
                        kiaArr.attrPresetList.forEach((ite,inx)=>list.push({label:ite,value:ite,id:inx,key:kiaArr.attrId+'_a'+inx}));
                        kiaArr.attrPresets = list;
                    }
                    if(kiaArr.attrValue&&!attValues[kiaArr.attrId]){// 详情无保存值且查询扩展属性有时带入
                        newObj[kiaArr.attrId] = kiaArr.attrValue;
                        newCategoryAttrList.push({
                            attrId: kiaArr.attrId,
                            attrValue: kiaArr.attrValue
                        })
                    }
                })
            }else {
                newObj={};//无下拉时清空下拉数据
                newCategoryAttrList=[]
            }
            setAttrList(option.categoryAttrList||[]);
            kizCategoryVO["catId"] = data;
            setAttValues(newObj);
            kizCategoryVO["categoryAttrList"] = newCategoryAttrList;
        }else {
            let categoryAttrList = kizCategoryVO.categoryAttrList||[];
            let currIem = categoryAttrList.find(item=>item.attrId==filed);
            if(currIem){
                currIem["attrValue"] = data;
            }else{
                categoryAttrList.push({
                    attrId: filed,
                    attrValue: data
                })
            }
            option.attrValue = data;
            // 校验用
            newObj[filed] = data;
            setAttValues(newObj);
            // 保存用
            kizCategoryVO["categoryAttrList"] = categoryAttrList;
        }
        setKizCategoryVO(kizCategoryVO);
        onChangeField(kizCategoryVO,'kizCategoryVO');
        // if(!flagInitAuto){ //对比值 判断显示
            checkUpdateGtin(isEmptyObject(yKiaObj)?null:yKiaObj,newObj,kizCategoryVO)
        // }
    }
    // 对比卡片
    const checkUpdateGtin=(cardObj,newObj,kizVO)=>{
        const checkObj = cardObj||kiaCard||{};
        const valueObj = newObj||attValues||{};
        const cateObj = kizVO||kizCategoryVO||{};
        // console.log("对比卡片 checkObj",checkObj);
        // console.log("对比卡片 valueObj",valueObj);
        // console.log("对比卡片 cateObj",cateObj);
        if(checkObj&&checkObj.isSelect){
            if(cateObj.catId!=checkObj.catId){
                onChangeField(true,'isUpdateGtin');
                return
            }else {
                // console.log("对比卡片 categoryAttrList",checkObj["categoryAttrList"]);
                const hadItem = checkObj.categoryAttrList.find(arr=>arr.attrValue!==valueObj[arr.attrId]);
                // console.log("对比卡片 hadItem",hadItem);
                if(hadItem&&hadItem.attrId){
                    onChangeField(true,'isUpdateGtin');
                    return
                }else {
                    // console.log("对比卡片 isUpdateGtin",false);
                    onChangeField(false,'isUpdateGtin');
                }
            }
        }
    }
    /**
     * 行编 e.target.value
     *
     * */
    const onChangeField=(value,field,e)=>{
        if(!isEdit) return;
        if(field=='stickerIconCodeList'){
            let stickerIconCodeList = curChaObj.stickerIconCodeList||[];
            if(matchCode(value,stickerIconCodeList)){
                curChaObj[field] = stickerIconCodeList.filter((item) => item !== value);
            }else{
                stickerIconCodeList.push(value);
                curChaObj[field] = stickerIconCodeList;
            }
        }else{
            curChaObj[field] = value;
            if(field=='stickerItem'){
                curChaObj['stickerCode'] = value.stickerCode;
                curChaObj['newStickerList'] = [value];
            }
            if(field=='goodsCertificateList'){
                curChaObj['hasCertificate'] = value&&value.length>0?1:null;
                curChaObj['hasCertificateList'] = value&&value.length>0?1:null;
            }
            if(field=="nameRu"){
                // onChangeField(true,'isUpdateGtin');
            }
            if(field=='customsCode'&&value&&value.length==10){
                // onChangeField(true,'isUpdateGtin');
                if(curChaObj.isMandatoryFlag){
                    getGtinInfo(curChaObj)
                }
            }
            if(field=='isMandatoryFlag'&&value&&curChaObj.customsCode&&curChaObj.customsCode.length==10){
                getGtinInfo(curChaObj)
            }
        }
        setCurChaObj({...curChaObj});
        saveOther(curChaObj)
        if(!isHadEdit&&isEdit&&setHadEdit){
            setHadEdit(true);
        }
    }
    curChaObj.disabled = isEdit?false:true;
    const required = (curChaObj.hasCertificate==1 || curChaObj.hasCertificate==2)?true:false;

    return (<div className={`itemLi${curChaObj.isTort==1?" itemLiTort":""}`} key={"itemLi_"+inx}>
        <div className={'pro'}>
            {/* 中国直达新增 isTort :1 商品侵权 */}
            {curChaObj.isTort==1?<span className={"labelTort"}>{Lang({id: 'ChanPinYiQinQuan', default: '产品已侵权'})}</span>:null}

            <LazyLoad height={0} once={true} offset={0}>
                {curChaObj.skuPictureUrl&&<ImageHover src={curChaObj.skuPictureUrl} size={400} key={"img_"+inx} />}
                <LoadFree onNodeload={()=>getGtinInfo(curChaObj)}></LoadFree>
            </LazyLoad>
        </div>
        <div className={'info'}>
            <div className='skuName'>
                {curChaObj.showEnTitle===1?<p className='skuName-line'>
                                <span className='skuName-translate-icon' onClick={()=>onChangeField(0,'showEnTitle')}>
                                EN
                                </span><a href={portalUrl+`/${curChaObj.goodsId}.html?skuNo=${curChaObj.skuNo}`} target={'_blank'}>{curChaObj.skuNameEn}</a>
                    </p>:<p className='skuName-line' onClick={()=>onChangeField(1, 'showEnTitle',true)}>
                                <span className='skuName-translate-icon'>
                                RU
                                </span><a href={portalUrl+`/${curChaObj.goodsId}.html?skuNo=${curChaObj.skuNo}`} target={'_blank'}>{curChaObj.skuNameRu}</a>
                    </p>}
            </div>
            <div className={'desc'}>
                <Row gutter={24}>
                    <Col span={6} className={'descItem'}>{Lang({id: 'ShangPinBianMa', default: '商品编码'})}<span>{curChaObj.skuNo}</span></Col>
                    <Col span={6} className={'descItem'}>{Lang({id: 'LeiMu', default: '类目'})}<span>{curChaObj.categoryName}</span></Col>
                    <Col span={12} className={'descItem'}>{Lang({id: 'CaiZhi', default: '材质'})}<span>{curChaObj.mainMaterials}</span></Col>
                    {/* <Col span={6} className={'descItem'}>{Lang({id: 'HaiGuanBianMa', default: '海关编码'})}<span>{curChaObj.customsCode}</span></Col> */}
                    {renderAttribute(curChaObj.attributeList)}
                </Row>
            </div>
            <div className={'cerSetBox'}>
                {/* 海关编码 */}
                {renderRow(Lang({id: 'HaiGuanBianMa', default: '海关编码'}),required,
                    isEdit?<div key={"sCus_"+inx}>
                            <div className={"flex-item"}>
                                <Input className={"essa-ant-input mr_12 mb_8"}
                                       style={{width:"200px"}}
                                       key={"sCustode_"+inx}
                                       // defaultValue={curChaObj.customsCode}
                                       value={curChaObj.customsCode}
                                       onChange={(e) =>{
                                           onChangeField(e.target.value, 'customsCode',);
                                       }}  />
                                    {/* 可点击赋值的海关编码列表 */}
                                    {curChaObj.customsCodeList&&curChaObj.customsCodeList.length>0?<>
                                                    {curChaObj.customsCodeList.map((sCusCode,inx)=><span className={"greyBtn"} key={"greyBtn_"+inx}
                                                                                    onClick={()=>onChangeField(sCusCode, 'customsCode')}>{sCusCode}</span>)}</>:null}
                            </div>
                            {/* 校验 */}
                            {(isSubmit==1&&required&&isEmpty(curChaObj.customsCode))||(!isEmpty(curChaObj.customsCode)&&curChaObj.customsCode.length!==10)?<div className={"color-err"}>
                                {Lang({id: 'QingShuRuHaiGuanBianMa', default: '请输入十位数的海关编码'})}
                            </div>:null}
                    </div>:curChaObj.customsCode,
                )}
                {/* 增值税率 */}
                {renderRow(Lang({id: 'ZengZhiShuiLv', default: '增值税率'}),required,
                    isEdit?<div key={"sTar_"+inx}>
                        <div className={"flex-item"}>
                            <InputNumber
                                   style={{width:"200px"}}
                                   key={"sTariffRate_"+inx}
                                   step={1}
                                   min={0.01}
                                   max={100}
                                // defaultValue={curChaObj.customsCode}
                                   value={curChaObj.importTariffRateNew}
                                   precision={2}
                                   addonAfter={'%'}
                                   onChange={(v) =>{
                                       onChangeField(v, 'importTariffRateNew',);
                                   }}
                            />
                        </div>
                        {/* 校验 */}
                        {(isSubmit==1&&required&&isEmpty(curChaObj.importTariffRateNew))?<div className={"color-err"}>
                            {Lang({id: 'QingShuRuZengZhiShuiLv', default: '请输入增值税率'})}
                        </div>:null}
                    </div>:curChaObj.importTariffRateNew,
                )}
                {/* 商品证书 */}
                {renderRow(Lang({id: 'ShangPinZhengShu', default: '商品证书'}),required,
                    <div key={"sCer_"+inx}>
                        <div className='CertificateType'>
                            {isEdit?<CertificateNew categoryId={curChaObj.topCategoryId}
                                                    callBack={(value=[]) =>onChangeField(value,'goodsCertificateList')}
                                                    goodsCertificateList={curChaObj.goodsCertificateList}>
                                                <span className={`CertificateType-option ${curChaObj.hasCertificate == 1?'cur':''}`}>{Lang({id: 'YouZhengShu', default: '有证书'})}
                                                    <span className="ri-edit-line" style={{float:'right'}}></span>
                                                </span>
                            </CertificateNew>:<span className={`CertificateType-option ${curChaObj.hasCertificate == 1?'cur':''}`}
                                                    onClick={(e) => {onChangeField(1, 'hasCertificate')}}>
                                                {Lang({id: 'YouZhengShu', default: '有证书'})}
                                </span>}
                            <span className={`CertificateType-option ${curChaObj.hasCertificate == 0?'cur':''}`}
                                  onClick={(e) => {onChangeField(0,'hasCertificate')}}>
                                                    {Lang({id: 'WuZhengShu', default: '无证书'})}
                                    </span>
                            <span className={`CertificateType-option ${curChaObj.hasCertificate == 2?'cur':''}`}
                                  onClick={(e) => {onChangeField(2,'hasCertificate')}}>
                                                    {Lang({id: 'WuZhengShuChuHuo', default: '无证书出货'})}
                                    </span>
                        </div>
                        {(isEmpty(curChaObj.hasCertificate)||curChaObj.hasCertificate===1)&&curChaObj.hasCertificateList === 1?<div
                            className='CertificateList mt_8 mb_8'>
                            {curChaObj.goodsCertificateList && curChaObj.goodsCertificateList.map((value,cerInx) => {
                                return <span className='CertificateItem' key={"cer_"+cerInx}>
                                                            {value.code}
                                                        </span>
                            })}
                        </div>:null}
                        {/* 证书 或 备注 start */}
                        {curChaObj.hasCertificate==1&&(curChaObj.certificateCode||curChaObj.remark?<div className={'cerShow'}>
                                {curChaObj.certificateCode&&<p>
                                    {Lang({id: 'certificateEncoding', default: '证书编码'})}
                                    <span>{curChaObj.certificateCode}</span>
                                </p>}
                                {curChaObj.hasRemark&&<p>
                                    {Lang({id: 'BeiZhu', default: '备注'})}<span>{curChaObj.hasRemark}</span>
                                </p>}
                            </div>:null)}
                        {/* 证书 或 备注 end */}
                        {/* 请填写无证书说明 出现时必填  */}
                        {curChaObj.hasCertificate==0?<div className={"mt_8"}>
                            <TextArea placeholder={Lang({id: 'QingTianXieWuZhengShuShuoMing', default: '请填写无证书说明'})}
                                                          key={'remark_'+inx}
                                                          value={curChaObj.remark}
                                                          onChange={(e)=>onChangeField(e.target.value,'remark')} disabled={curChaObj.disabled} />
                        </div>:null}
                        {/* 校验 */}
                        {isSubmit==1?<>
                            {isEmpty(curChaObj.hasCertificate)?<div className={"color-err"}>
                                {Lang({id: 'QingXuanZeShiFouYouShangPinZhengShu', default: '请选择是否有商品证书'})}
                            </div>:null}
                            {curChaObj.hasCertificate === 1&&(!curChaObj.goodsCertificateList || curChaObj.goodsCertificateList.length ===0 )?<div className={"color-err"}>
                                {Lang({id: 'NinShangWeiXuanZeZhengShu', default: '您尚未选择证书'})}
                            </div>:null}
                            {curChaObj.hasCertificate === 0&&isEmpty(curChaObj.remark)?<div className={"color-err"}>
                                {Lang({id: 'QingTianXieWuZhengShuShuoMing', default: '请填写无证书说明'})}
                            </div>:null}
                        </>:null}
                    </div>)}
                {/* 贴纸图标  只有线下交易的客户，才出现这个需要填写 start */}
                {model.isOfflineTrade==1?renderRow(Lang({id: 'TieZhiTuBiao', default: '贴纸图标'}),false,
                    curChaObj.disabled?<div key={'iconCode_'+inx}>
                        {iconCodeList.map((icon,iIx)=>{
                                return icon.remark&&matchCode(icon.code,curChaObj.stickerIconCodeList)?(<div className={`iconCode iconCodeOn`} key={'iconC_'+iIx}>
                                    <img src={icon.remark} style={{width:'52px',height:'52px'}} />
                                </div>):null
                            }
                        )}
                    </div>:<div className={"flex-item iconCodeBox"} key={'iconCode_'+inx}>
                        {iconCodeList.map((icon,iIx)=>{
                                if(!iconCodeMore&&iIx>=10) return;
                                return icon.remark?(<div className={`iconCode${matchCode(icon.code,curChaObj.stickerIconCodeList)?" iconCodeOn":""}`} key={'iconC_'+iIx} onClick={()=>onChangeField(icon.code,"stickerIconCodeList",)}>
                                    <img src={icon.remark} style={{width:'52px',height:'52px'}} />
                                </div>):null
                            }
                        )}
                        {iconCodeList&&iconCodeList.length>10&&!iconCodeMore?<span className={'font-main2 iconCodeMore'} onClick={()=>setIconCodeMore(true)}>{Lang({id: 'GengDuo', default: '更多'})}</span>:null}
                    </div>):null}
                {/* 贴纸图标 */}
                {/* 贴纸模板 start */}
                {renderRow(Lang({id: 'TieZhiMoBan', default: '贴纸模板'}),required,
                    curChaObj.disabled?<span key={'newSti_'+inx}>{curChaObj.stickerName||curChaObj.stickerCode}</span>:<div key={'newSti_'+inx}>
                            <StickerTemplateSelector key={"stickerCode_tem_"+inx}
                                                     source={curChaObj.stickerTemplateList}
                                                     newStickerList={curChaObj.newStickerList}
                                                     currentItem={curChaObj.stickerItem}
                                                     onSelectBack={(data)=>onChangeField(data,'stickerItem')}
                                                     sku={curChaObj} />
                        {/* 校验 */}
                        {isSubmit==1&&required&&!curChaObj.stickerCode?<div className={"color-err"}>
                            {Lang({id: 'XuanZeTieZhiMoBan', default: '选择贴纸模板'})}
                        </div>:null}
                    </div>)}
                {/* 贴纸品名 */}
                {renderRow(Lang({id: 'TieZhiPinMing', default: '贴纸品名'}),required,
                    isEdit?<div key={'nameRu_'+inx}>
                                <TextArea id={'TextArea_Copy_'+inx} key={'TextArea_Copy_'+inx}
                                          placeholder={Lang({id: 'TieZhiPinMing', default: '贴纸品名'})}
                                          // defaultValue={curChaObj.nameRu}
                                          value={curChaObj.nameRu}
                                          onChange={(e)=>onChangeField(e.target.value,'nameRu')}
                                          disabled={curChaObj.disabled} />
                        <div className={'copyOption'}>
                            <CopyAndPaste optionId={'TextArea_Copy_'+inx}
                                          pasteRes={(value)=>onChangeField(value,'nameRu')} />
                        </div>
                        {/* 校验 */}
                        {isSubmit==1&&required&&isEmpty(curChaObj.nameRu)?<div className={"color-err"}>
                            {Lang({id: 'SheZhiTieZhiPinPai', default: '设置贴纸品名'})}
                        </div>:null}
                    </div>:curChaObj.nameRu)}
                {/* 商品描述 扩展复制粘贴*/}
                {renderRow(Lang({id: 'HaiGuanShangPinBiaoMiaoShu', default: '海关商品表描述'}),false,
                    isEdit?<div key={'goodsDesc_'+inx}>
                               <TextArea id={'GoodDesc_Copy_'+inx}
                                         key={'GoodDesc_Copy_'+inx}
                                         placeholder={Lang({id: 'HaiGuanShangPinBiaoMiaoShu', default: '海关商品表描述'})}
                                         // defaultValue={curChaObj.goodsDesc}
                                         value={curChaObj.goodsDesc}
                                         onChange={(e)=>onChangeField(e.target.value,'goodsDesc')}
                                         disabled={curChaObj.disabled} />
                        <div className={'copyOption'}>
                            <CopyAndPaste optionId={'GoodDesc_Copy_'+inx}
                                          pasteRes={(value)=>onChangeField(value,'goodsDesc')} />
                        </div>
                    </div>:curChaObj.goodsDesc)}
                {/* 商品描述 end*/}

                {/* 诚实标志内容  */}
                {renderRow(Lang({id: 'ShiFouQiangZhiBiaoJi', default: '是否强制标记'}),required,
                    curChaObj.disabled?<span key={'isManda_'+inx}>{Lang((curChaObj.isMandatoryFlag)?{id: 'Shi', default: '是'}:{id: 'Fou', default: '否'})}</span>:<div key={'isManda_'+inx}>
                        <Switch checked={curChaObj.isMandatoryFlag||curChaObj.isMandatoryFlag==1} onChange={(checked)=>onChangeField(checked,'isMandatoryFlag')} />
                    </div>)}
                {curChaObj.isMandatoryFlag?<div key={"MstoryF_"+inx}>
                        {kiaCard.gtinCode?renderRow("GTIN",false,<div  key={'feLei_'+inx}>
                            <span className={curChaObj.isUpdateGtin?"black89 util-del":"black89"}>{kiaCard.gtinCode}</span>
                            {curChaObj.isUpdateGtin&&<span className={"color-err ml_6"}>{Lang({id: 'ShangPinXinXiYouXiuGaiXuZ', default: '商品信息有修改需重新申请'})}</span>}
                        </div>):null}
                        {/*商品分类 */}
                        {(kizAttrList&&kizAttrList.length>0||curChaObj.disabled)?renderRow(Lang({id: 'ShangPinFenLeiS', default: '商品分类'}),true,curChaObj.disabled?<span key={'feLei_'+inx}>{kizCategoryVO.catValueName}</span>:<div key={'feLei_'+inx}>
                            <Select options={kizAttrList}
                                    style={{ width: '100%' }}
                                    value={kizCategoryVO.catId}
                                    onChange={(v,opt)=>handleKiaChange("cate",v,opt)}
                                    fieldNames={{label:"catValueName",value:"catId"}} />
                            {/* 校验 */}
                            {((isSubmit===0||isSubmit==1)&&isEmpty(kizCategoryVO.catId))?<div className={"color-err"}>
                                {Lang({id: 'QingXuanZeShangPinFenLei', default: '请选择商品分类'})}
                            </div>:null}
                        </div>):null}
                    {attrList.map(att=>{
                        if(att.attrPresetOnly){
                            return renderRow(att.attrName,true,curChaObj.disabled?attValues[att.attrId]:<div key={att.attrId+'fi_'+inx}>
                                <Select options={att.attrPresets||[]}
                                        // mode={att.attrMultiplicity?"multiple":""}
                                        style={{ width: '100%' }}
                                        value={attValues[att.attrId]}
                                        onChange={(value,opt)=>handleKiaChange(att.attrId,value,opt)} />
                                {/* 校验 */}
                                {((isSubmit===0||isSubmit==1)&&isEmpty(attValues[att.attrId]))?<div className={"color-err"}>
                                    {att.attrName}
                                </div>:null}
                            </div>)
                        }else if(att.attrFieldType=='text'){
                            return renderRow(att.attrName,true,
                                isEdit?<div key={att.attrId+'_in'+inx}>
                                    <div>
                                        <Input className={"essa-ant-input mr_12 mb_8"}
                                               key={att.attrId+'_'+inx}
                                               style={{ width: '100%' }}
                                               value={attValues[att.attrId]}
                                               onChange={(e) =>{
                                                   handleKiaChange(att.attrId,e.target.value,att);
                                               }}  />
                                    </div>
                                    {/* 校验 */}
                                    {((isSubmit===0||isSubmit==1)&&isEmpty(attValues[att.attrId]))?<div className={"color-err"}>
                                        {att.attrName}
                                    </div>:null}
                                </div>:attValues[att.attrId],
                            )
                        }else if(att.attrFieldType=='number'){
                            return renderRow(att.attrName,true,
                                isEdit?<div key={att.attrId+'_tet'+inx}>
                                    <div>
                                        <InputNumber style={{ width: '100%' }} key={att.attrId+'_'+inx}
                                            step={1}
                                            value={attValues[att.attrId]}
                                            onChange={(v) =>handleKiaChange(att.attrId,v,att)}
                                        />
                                    </div>
                                    {/* 校验 */}
                                    {((isSubmit===0||isSubmit==1)&&isEmpty(attValues[att.attrId]))?<div className={"color-err"}>
                                        {att.attrName}
                                    </div>:null}
                                </div>:attValues[att.attrId],
                            )
                        }
                        // else if(att.attrFieldType=='date'){
                        //     return renderRow(att.attrName,true,
                        //         isEdit?<div key={att.attrId+'_date'+inx}>
                        //             <div>
                        //                 <DatePicker style={{ width: '100%' }}
                        //                             key={att.attrId+'_'+inx}
                        //                             value={attValues[att.attrId]}
                        //                             onChange={(dates) =>handleKiaChange(att.attrId,dates,att)} />
                        //             </div>
                        //             {/* 校验 */}
                        //             {((isSubmit===0||isSubmit==1)&&isEmpty(attValues[att.attrId]))?<div className={"color-err"}>
                        //                 {att.attrName}
                        //             </div>:null}
                        //         </div>:(attValues[att.attrId]?dayjs(attValues[att.attrId]).format('YYYY-MM-DD'):'-'),
                        //     )
                        // }
                    })}
                </div>:null}
            </div>
        </div>
    </div>);
};

export default OneItem;